<template>
  <div>
    <WebHeaderView :title="'团队详情'" />

    <div class="page-content">
      <van-tabs
        @click="tabClick"
        v-model="active"
        color="#fff"
        title-active-color="#fff"
      >
        <van-tab title="我的代理" :name="1" />
        <van-tab title="我的玩家" :name="2" />
      </van-tabs>
      <van-search
        v-model="params.keyword"
        show-action
        placeholder="请输入搜索ID/昵称"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="isnorecord && isnorecord == 0">
          <van-empty description="暂无记录" />
        </div>
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-if="active == 2" style="width: 96%; margin: 0px auto">
            <van-row>
              <van-col
                span="6"
                style="
                  border: 1px solid #fff;
                  padding: 4px 0;
                  font-weight: 600;
                  height: 38px;
                  line-height: 38px;
                "
                >ID</van-col
              >
              <van-col
                span="6"
                style="
                  border: 1px solid #fff;
                  padding: 4px 0;
                  font-weight: 600;
                  height: 38px;
                  line-height: 38px;
                "
                >名称</van-col
              >
              <van-col
                span="6"
                style="
                  border: 1px solid #fff;
                  padding: 4px 0;
                  font-weight: 600;
                  height: 38px;
                  line-height: 38px;
                "
                >今日流水</van-col
              >
              <van-col
                span="6"
                style="
                  border: 1px solid #fff;
                  padding: 4px 0;
                  font-weight: 600;
                  height: 38px;
                  line-height: 38px;
                "
                >授权</van-col
              >
            </van-row>
          </div>
          <div v-if="active == 2">
            <UsrInfoView2
              v-for="(item, index) in list"
              :key="index"
              :item="item"
              @change-zhekou="toShow"
            />
          </div>
          <div v-if="active == 1">
            <AgentInfoView
              v-for="(item, index) in list"
              :key="index"
              :item="item"
              :isArea="usr.region_authorization"
              @change-zhekou="toShow"
            />
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup
      v-model="toshow"
      v-if="toshow"
      closeable
      round
      :style="{ width: '90%' }"
    >
      <div class="safe-box">
        <div class="title" v-if="tempInf.isagent != 1">
          玩家 {{ tempInf.nickname }} 授权代理
        </div>
        <div class="title" v-else>
          {{ tempInf.nickname }} 调整
          <span style="color: red; font-weight: 600">{{
            bustype == 0 ? '代理' : '大区'
          }}</span>
          比例({{
            bustype == 0 ? tempInf.fanshuifee : tempInf.region_fanshuifee
          }}%)
        </div>
        <van-form @submit="onSubmit" ref="frm">
          <van-field
            v-model="frm.fanshuifee"
            label="授权比例"
            type="number"
            :formatter="formatter"
            placeholder="请填写授权比例"
            :rules="[{ required: true, message: '请填写授权比例' }]"
          />
          <div style="margin: 16px">
            <van-button round block type="info" native-type="submit"
              >确认</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import { AgentInfoView, UsrInfoView2 } from './components/index'
export default {
  name: 'TeamInfoView',
  components: {
    WebHeaderView,
    AgentInfoView,
    UsrInfoView2
  },
  data () {
    return {
      active: 2,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      isnorecord: null,
      params: {
        type: 2,
        limit: 20,
        page: 1,
        keyword: null
      },
      toshow: false,
      tempInf: null,
      frm: {
        user_id: null,
        fanshuifee: null
      },
      bustype: 0,
      usr:{}
    }
  },
  methods: {
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
        if (this.usr.region_authorization == 1) {
         // this.RegionFanshuiInfo()
        }
      })
    },
    onSearch () {
      this.onRefresh()
    },
    toShow (item, type) {
      this.bustype = type
      this.toshow = true
      this.tempInf = item
      this.frm.user_id = item.id
    },
    formatter (value) {
      const decimalRegex = /(\.\d{2})\d+/
      return value.replace(decimalRegex, '$1')
    },
    onSubmit () {
      if (this.bustype == 1) this.onSubmit2()
      else this.onSubmit1()
    },
    async onSubmit1 () {
      await this.$http({
        method: 'post',
        url: 'AgentFanshuiFee',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.toshow = false
          this.tempInf = null
          this.frm = {
            user_id: null,
            fanshuifee: null
          }
          this.onRefresh()
        }
      })
    },
    async onSubmit2 () {
      await this.$http({
        method: 'post',
        url: 'setAgentRegionFanshuiFee',
        data: {
          user_id: this.frm.user_id,
          region_fanshuifee: this.frm.fanshuifee
        }
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.toshow = false
          this.tempInf = null
          this.frm = {
            user_id: null,
            fanshuifee: null
          }
          this.onRefresh()
        }
      })
    },

    tabClick () {
      this.params.type = this.active
      this.onRefresh()
    },
    onRefresh () {
      this.params.page = 1
      this.isnorecord = null
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.onLoad()
    },
    onLoad () {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      this.getDta()
    },
    async getDta () {
      await this.$http({
        method: 'post',
        url: 'AgentTeamList',
        data: this.params
      }).then(data => {
        this.loading = false
        this.isnorecord = data.data.total
        this.list = this.list.concat(data.data.list)
        if (this.list.length >= data.data.total) {
          this.finished = true
        } else {
          this.params.page += 1
        }
      })
    }
  },
  mounted(){
    this.getusrInf()
  }
}
</script>

<style lang="scss" scoped>
.safe-box {
  margin: 10px;
  padding: 10px;
  width: 80vw;
  .title {
    height: 38px;
    line-height: 38px;
    color: #000;
    text-align: center;
  }
}
</style>
